<template>
    <div>
        <el-switch :inactive-text="$lang('activeSwitch')"
                   class="a-popover__switch switch switch--small"
                   v-model="deleted"
                   @change=change>
        </el-switch>
    </div>
</template>

<script>
    export default {
        name: "activeSwitch",
        props: ['id','deleted'],
        data: function () {
            return {}
        },
        methods: {
            change() {
                this.$emit('action',{id: this.id, active: this.deleted});
            }
        },
    }
</script>
